module.exports = __webpack_public_path__ + "static/logotest-d5e633fbdcaf8835ec57ca08066b1234.png";